import React                      from 'react'
import { toJS }                   from 'mobx'
import { Observer }               from 'mobx-react'

import { TEXT
       , tr }                     from '../00_assets'
import { kde_api_client_contact_t
       , kde_api_client_contact_fields_t
       , kde_api_client_address_t
       , kde_api_client_address_fields_t
       }                          from '../02_api'

import { FormInput
       , FIELD_TYPE
       , IFormEditor }            from './05_ui_form_input'
import { CONTACT_LABEL }          from './13_ui_render_contact'
import { ADDRESS_LABEL }          from './14_ui_render_address'



export function address_form_fields ( address: kde_api_client_address_t | null )
{
  return { address: { label: TEXT.CLIENT_ADDRESS
                    , init: address === null || address === undefined? null : toJS( address )
                    , type: FIELD_TYPE.CUSTOM
                    , is_valid: ( ) => 0
                    }
         } ;
}


export function contact_form_fields ( contact: kde_api_client_contact_t | null )
{
  return { contact: { label: TEXT.CLIENT_CONTACT
                    , init: contact === null || contact === undefined? null : toJS( contact )
                    , type: FIELD_TYPE.CUSTOM
                    , is_valid: ( ) => 0
                    }
         } ;
}


export const AddressEditor: React.FC< { form: IFormEditor } > = ( { form } ) =>
<Observer render={ ( ) => 
{ 
  const on_address_change = (what: kde_api_client_address_fields_t) => ( ev: React.ChangeEvent<HTMLInputElement> ) =>
        {
          if ( !form.model.address.value( ) )
               form.model.address.bind( ).onChange( { } ) ;
              
          form.model.address.value( )[ what ] = ev.target.value ;
        }
      , address_form  = ( what: kde_api_client_address_fields_t ) =>
        <FormInput
          label={ ADDRESS_LABEL[ what ] }
          value={ form.model.address.value( ) !== null? form.model.address.value( )[ what ] || '' : '' }
          onChange={ on_address_change( what ) }
        /> ;

  return <>
      <h3 className="mt-3">{ tr( TEXT.CLIENT_ADDRESS ) } </h3>
      { address_form( 'street1'  ) }
      { address_form( 'street2'  ) }
      { address_form( 'city'     ) }
      { address_form( 'zipCode'  ) }
      { address_form( 'province' ) }
      { address_form( 'country'  ) }
    </> ;
} } /> ;




export const ContactEditor: React.FC< { form: IFormEditor } > = ( { form } ) =>
<Observer render={ ( ) => 
{ 
  const on_contact_change = (what: kde_api_client_contact_fields_t) => ( ev: React.ChangeEvent<HTMLInputElement> ) =>
        {
          if ( !form.model.contact.value( ) )
               form.model.contact.bind( ).onChange( { } ) ;
              
          form.model.contact.value( )[ what ] = ev.target.value ;
        }
      , contact_form = ( what: kde_api_client_contact_fields_t ) =>
        <FormInput
          label={ CONTACT_LABEL[ what ] }
          value={ form.model.contact.value( ) !== null? form.model.contact.value( )[ what ] || '' : '' }
          onChange={ on_contact_change( what ) }
        /> ;

  return <>
      <h3 className="mt-3">{ tr( TEXT.CLIENT_CONTACT ) } </h3>
      { contact_form( 'email' ) }
      { contact_form( 'phone' ) }
      { contact_form( 'fax'   ) }
    </> ;
} } /> ;